import { FC, memo, useEffect } from 'react'
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Flex,
  Text,
  useDisclosure,
} from '@chakra-ui/react'

type Props = {
  shouldBeOpened?: boolean
  content: JSX.Element
  title: string
}

const CustomAccordionForFilter: FC<Props> = ({ shouldBeOpened = true, content, title }) => {
  const { isOpen, onClose, onOpen } = useDisclosure()

  function toggleAccordion() {
    if (isOpen) {
      onClose()
    } else {
      onOpen()
    }
  }

  useEffect(() => {
    if (shouldBeOpened) onOpen()
  }, [shouldBeOpened])

  return (
    <Accordion index={isOpen ? [0] : [1]} allowMultiple>
      <AccordionItem bg="light" border="none" borderBottom="2px solid" borderColor="borderColor">
        {({ isExpanded }) => (
          <>
            <AccordionButton p={4} border="none" onClick={toggleAccordion}>
              <Flex width="100%" direction="column">
                <Flex justify="space-between" gap={2}>
                  <Text fontWeight="bold" fontSize="lg">
                    {title}
                  </Text>

                  <AccordionIcon boxSize={6} />
                </Flex>
              </Flex>
            </AccordionButton>

            <AccordionPanel pb={4}>{isExpanded && content}</AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  )
}

export default memo(CustomAccordionForFilter)
